<div class="game-box">
	<!-- 游戏类型切换 -->
	<ul class="game-tabs">
		<ng-container *ngIf="gameCategoryList && gameCategoryList.List">
			<li *ngFor="let category of gameCategoryList.List"
				[ngClass]="{ active: selectedGameType === category.Name }" class="game-ico"
				[style.background-image]="'url(../../assets/images/contents/game/' + category.Icon + ')'"
				(click)="handleGameList(category.Name)">
				<div class="">
					{{ category.DisplayName }}
					<!-- <div class="game-ico-icon">
						<img [src]="'../../assets/images/contents/game/' + category.Icon" alt="{{ category.Name }}" />
					</div> -->
					<!-- <p style="font-size: 12px; margin-bottom: 0;"> {{ category.DisplayName }} </p> -->
				</div>
			</li>
		</ng-container>
	</ul>

	<!-- 游戏列表/进入游戏 -->
	<div class="game-list type0">
		<ng-container *ngIf="gameCategoryList && gameCategoryList.List">
			<ng-container *ngFor="let category of gameCategoryList.List; let i = index;">
				<ng-container *ngIf="selectedGameType === category.Name">
					<ng-container *ngIf="
					((category.SupplierGames && category.SupplierGames.length > 0) ||
						(category.HotGames && category.HotGames.length > 0));
					else ComingSoon
					">
						<!-- 供应商 -->
						<div *ngIf="category.SupplierGames && category.SupplierGames.length > 0"
							class="game-list-brand">
							<div class="d-flex justify-content-between">
								<div class="align-self-center">
									<h4 class="game-list-title game-list-title-supplier i18n" data-tag="supplier"
										style="display: block;">
										{{'contents.game.supplier' | translate}}</h4>
								</div>
								<div class="align-self-center">
									<div class="slider">
										<div *ngIf="showButtons[i]" class="slider-left" (click)="scrollLeft(i)">
											<img src="../../../../assets/images/contents/game/left.png" alt="">
										</div>
										<div *ngIf="showButtons[i]" class="slider-right" (click)="scrollRight(i)">
											<img src="../../../../assets/images/contents/game/right.png" alt="">
										</div>
									</div>
								</div>
							</div>

							<div class="game-list-brand-box" #scrollableDivs>
								<ng-container *ngFor="let game of category.SupplierGames;">
									<div class="game-item 
										{{ game.IsMaintenance ? 'maintenance-overlay' : ''}}
										{{ game.TagCodes && game.TagCodes.includes('is-coming-soon') ? 'coming-soon-overlay' : ''}}
										{{ this.auth.testGame && !game.IsMaintenance && !game.IsFun ? 'not-support-testgame-overlay' : '' }}"
									>
									<!-- <div class="game-item 
										{{ game.IsMaintenance ? 'maintenance-overlay' : ''}}
										{{ game.TagCodes && game.TagCodes.includes('is-coming-soon') ? 'coming-soon-overlay' : ''}}
										{{ game.TagCodes && game.TagCodes.includes('is-board-game') ? 'board-game-overlay' : ''}}
										{{ game.TagCodes && game.TagCodes.includes('is-progressive-slot') ? 'progressive-slot-overlay' : ''}}
										{{ game.TagCodes && game.TagCodes.includes('is-fishing') ? 'fishing-overlay' : ''}}
										{{ game.TagCodes && game.TagCodes.includes('is-slot') ? 'slot-overlay' : ''}}
										{{ game.TagCodes && game.TagCodes.includes('is-hot') ? 'hot-overlay' : ''}}
										{{ game.TagCodes && game.TagCodes.includes('is-new') ? 'new-overlay' : ''}}
										{{ game.TagCodes && game.TagCodes.includes('is-event') ? 'event-overlay' : ''}}
										{{ this.auth.testGame && !game.IsMaintenance && !game.IsFun ? 'not-support-testgame-overlay' : '' }}"
									> -->
										<div *ngIf="game.IsMaintenance" class="maintenance">
											<div> {{'contents.game.maintenance' | translate}} </div>
										</div>
										<div *ngIf="game.TagCodes && game.TagCodes.includes('is-coming-soon')" class="coming-soon"> 
											<div> {{'contents.game.comingSoon' | translate}} </div>
										</div>

										<!-- <div *ngIf="game.TagCodes && game.TagCodes.includes('is-board-game')" class="board-game">
											<div> {{ 'contents.game.board_game' | translate}} </div>
										</div>

										<div *ngIf="game.TagCodes && game.TagCodes.includes('is-progressive-slot')" class="progressive-slot">
											<div> {{ 'contents.game.progressive_slot' | translate}} </div>
										</div>

										<div *ngIf="game.TagCodes && game.TagCodes.includes('is-fishing')" class="fishing">
											<div> {{ 'contents.game.fishing' | translate}} </div>
										</div>

										<div *ngIf="game.TagCodes && game.TagCodes.includes('is-slot')" class="slot">
											<div> {{ 'contents.game.slot' | translate}} </div>
										</div>

										<div *ngIf="game.TagCodes && game.TagCodes.includes('is-hot')" class="hot">
											<div> {{ 'contents.game.hot' | translate}} </div>
										</div>

										<div *ngIf="game.TagCodes && game.TagCodes.includes('is-new')" class="new">
											<div> {{ 'contents.game.new' | translate}} </div>
										</div>

										<div *ngIf="game.TagCodes && game.TagCodes.includes('is-event')" class="event">
											<div> {{ 'contents.game.event' | translate}} </div>
										</div> -->

										<div *ngIf="this.auth.testGame && !game.IsMaintenance && !game.IsFun && (!game.TagCodes || !game.TagCodes.includes('is-coming-soon'))" class="not-support-testgame">
											<div> {{'contents.game.notSupportTestGame' | translate}} </div>
										</div>

										<div class="game-item-top" (click)="enterGame(game, true);">
											<img [src]="getImageSource(game)">

											<div class="game-item-start">
												<em class="brand-name i18n">
													{{ getSupplierDisplayName(game) }}
												</em>
											</div>
										</div>
										<div class="unfree" style="display: none">
											<img src="../../assets/images/contents/game/unfree.png" />
											<span class="i18n" data-tag="unfree">Trial play is not supported</span>
										</div>
									</div>
								</ng-container>
							</div>
						</div>
						<!-- end 供应商 -->
						<!-- 热门 -->
						<div *ngIf="category.HotGames && category.HotGames.length > 0" class="game-list-hot">
							<div class="game-list-title game-list-title-hot i18n" data-tag="hot" style="display: block">
								{{ 'contents.game.hot' | translate }}
							</div>
							<div class="game-list-hot-box">
								<ng-container *ngFor="let game of category.HotGames">
									<div class="game-item class-4 
										{{ game.IsMaintenance ? 'maintenance-overlay' : ''}}
										{{ game.TagCodes && game.TagCodes.includes('is-coming-soon') ? 'coming-soon-overlay' : ''}}
										{{ this.auth.testGame && !game.IsMaintenance && !game.IsFun ? 'not-support-testgame-overlay' : '' }}">

									<!-- <div class="game-item class-4 
										{{ game.IsMaintenance ? 'maintenance-overlay' : ''}}
										{{ game.TagCodes && game.TagCodes.includes('is-coming-soon') ? 'coming-soon-overlay' : ''}}
										{{ game.TagCodes && game.TagCodes.includes('is-board-game') ? 'board-game-overlay' : ''}}
										{{ game.TagCodes && game.TagCodes.includes('is-progressive-slot') ? 'progressive-slot-overlay' : ''}}
										{{ game.TagCodes && game.TagCodes.includes('is-fishing') ? 'fishing-overlay' : ''}}
										{{ game.TagCodes && game.TagCodes.includes('is-slot') ? 'slot-overlay' : ''}}
										{{ game.TagCodes && game.TagCodes.includes('is-hot') ? 'hot-overlay' : ''}}
										{{ game.TagCodes && game.TagCodes.includes('is-new') ? 'new-overlay' : ''}}
										{{ game.TagCodes && game.TagCodes.includes('is-event') ? 'event-overlay' : ''}}
										{{ this.auth.testGame && !game.IsMaintenance && !game.IsFun ? 'not-support-testgame-overlay' : '' }}"> -->
										<div *ngIf="game.IsMaintenance" class="maintenance">
											<div> {{'contents.game.maintenance' | translate}} </div>
										</div>

										<div *ngIf="game.TagCodes && game.TagCodes.includes('is-coming-soon')" class="coming-soon"> 
											<div> {{'contents.game.comingSoon' | translate}} </div>
										</div>

										<!-- <div *ngIf="game.TagCodes && game.TagCodes.includes('is-board-game')" class="board-game">
											<div> {{ 'contents.game.board_game' | translate}} </div>
										</div>

										<div *ngIf="game.TagCodes && game.TagCodes.includes('is-progressive-slot')" class="progressive-slot">
											<div> {{ 'contents.game.progressive_slot' | translate}} </div>
										</div>

										<div *ngIf="game.TagCodes && game.TagCodes.includes('is-fishing')" class="fishing">
											<div> {{ 'contents.game.fishing' | translate}} </div>
										</div>

										<div *ngIf="game.TagCodes && game.TagCodes.includes('is-slot')" class="slot">
											<div> {{ 'contents.game.slot' | translate}} </div>
										</div>

										<div *ngIf="game.TagCodes && game.TagCodes.includes('is-hot')" class="hot">
											<div> {{ 'contents.game.hot' | translate}} </div>
										</div>

										<div *ngIf="game.TagCodes && game.TagCodes.includes('is-new')" class="new">
											<div> {{ 'contents.game.new' | translate}} </div>
										</div>

										<div *ngIf="game.TagCodes && game.TagCodes.includes('is-event')" class="event">
											<div> {{ 'contents.game.event' | translate}} </div>
										</div> -->

										<div *ngIf="this.auth.testGame && !game.IsMaintenance && !game.IsFun" class="not-support-testgame">
											<div> {{'contents.game.notSupportTestGame' | translate}} </div>
										</div>
										<div class="game-item-top" (click)="enterGame(game, false);">
											<div class="game-item-img">
												<img [src]="getImageSource(game)" />
												<!-- <div *ngIf="!game.IsMaintenance && this.auth.isAuthenticated()"
													class="game-item-start" [class.disabled]="game.IsMaintenance">
													<a [routerLink]="['/contents/pages/loading-page']"
														[queryParams]="{ providerCode: game.ProviderCode, gameCode: game.GameCode }"
														target="_blank" class="i18n" data-tag="startGame">
														{{ 'contents.game.join' | translate }}
													</a>
												</div>
												<div *ngIf="!game.IsMaintenance && !this.auth.isAuthenticated()"
													class="game-item-start" (click)="!game.IsMaintenance && joinGame()"
													[class.disabled]="game.IsMaintenance">
													<a href="javascript:void(0)" class="i18n" data-tag="startGame">{{
														'contents.game.join' | translate }} </a>
												</div> -->
											</div>
											<div class="unfree" style="display: none">
												<img src="../../assets/images/contents/game/unfree.png" />
												<span class="i18n" data-tag="unfree">Trial play is not supported</span>
											</div>
										</div>
										<em class="hot-name i18n">
											{{ getSupplierDisplayName(game) }}</em>
									</div>
								</ng-container>
							</div>
						</div>
						<!-- end 热门 -->
					</ng-container>

					<ng-template #ComingSoon>
						<div class="d-flex w-100 justify-content-center" style="margin-top: 130px">
							<div class="align-self-center">
								{{'contents.game.comingSoon' | translate}}
								<!-- <img src="../../assets/images/global/coming-soon.png" /> -->
							</div>
						</div>
					</ng-template>
				</ng-container>
			</ng-container>
		</ng-container>
	</div>
</div>